import { svg } from 'lit';
export const arrowLeft24Svg = svg `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 12L6 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 18L6 12L12 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
//# sourceMappingURL=arrow-left_24.svg.js.map